import { SpinBoundaryEndActionHandler, SpinBoundaryStartActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { CurrentWinSpinBoundary } from "./CurrentWinSpinBoundary";

/**
 * The running current-win panel across a round: armed at a spin boundary start, hidden by the first
 * frame revealed after it, set at the boundary end, and parked at the feature's total on exit.
 */
export function createCurrentWinPlugin(deps: { spinBoundary: CurrentWinSpinBoundary }): ReplayPlugin {
  const { spinBoundary } = deps;
  return {
    name: "current-win",
    actionHandlers: [
      new SpinBoundaryStartActionHandler((input, context) => spinBoundary.onSpinBoundaryStart(input, context)),
      new SpinBoundaryEndActionHandler((input, context) => spinBoundary.onSpinBoundaryEnd(input, context)),
    ],
    observer: {
      onFrameRevealed: async () => {
        // One-shot inside the spin boundary: only the first reveal after a boundary start hides the
        // previous spin's win; cascade reveals no-op.
        spinBoundary.onPostRevealFrame();
      },
      onFeatureState: async (event) => {
        const featureState = event.eventContent.featureState;
        if (featureState?.featurePhase !== "exit") return;
        // Park the feature's accumulated total so the round's grand total persists through the
        // finished panel and into the next base spin's reveal.
        spinBoundary.onFeatureExit(featureState.featureAccumulatedWinMinor ?? "0");
      },
    },
  };
}
